import styled, { css } from 'styled-components';

export const FilterWrapper = styled.div<{ horizontal: boolean }>`
  ${props =>
    props.horizontal
      ? css`
          display: flex;
          align-items: flex-start;
        `
      : null}
`;

export const FilterInput = styled.input`
  width: 100%;
  font-style: italic;
  margin-bottom: 10px;
  margin-top: 10px;
  border: 1px solid ${({ theme }) => theme.lines.secondary};
  padding: 5px;
  outline: 0;

  &:focus {
    border-color: ${({ theme }) => theme.lines.highlight};
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.lines.highlight};
  }
`;
